import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Navbar from "@/Common/Navbar";
import { useDispatch } from "react-redux";
import { updateUserInfo } from "../Redux/slices/authSlice";

const Settings = () => {
  const [user, setUser] = useState({ firstname: "", lastname: "", id: "" });
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const token = localStorage.getItem("authToken");
  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .get("http://127.0.0.1:8000/api/users/me/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setUser({
          firstname: res.data.first_name,
          lastname: res.data.last_name,
          id: res.data.id,
        });
      })
      .catch(() => toast.error("Failed to load profile"));
  }, [token]);

  const handleProfileUpdate = (e) => {
    e.preventDefault();
    axios
      .put(
        "http://127.0.0.1:8000/api/users/settings/update-profile/",
        {
          first_name: user.firstname,
          last_name: user.lastname,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        toast.success("Profile updated successfully");
        dispatch(updateUserInfo({ first_name: user.firstname, last_name: user.lastname }));
      })
      .catch(() => toast.error("Profile update failed"));
  };

  const handlePasswordChange = (e) => {
    e.preventDefault();
    axios
      .post(
        "http://127.0.0.1:8000/api/users/settings/change-password/",
        {
          old_password: oldPassword,
          new_password: newPassword,
          confirm_new_password: confirmNewPassword,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        toast.success("Password changed successfully");
        setOldPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
      })
      .catch((err) =>
        toast.error(err.response?.data?.error || "Password change failed")
      );
  };

  return (
    <div className="flex bg-gradient-to-br from-[#0f0f1a] to-[#1a1a2e] min-h-screen text-white">
      <Navbar />
      <div className="flex-1 flex flex-col items-center justify-start px-6 py-12 ml-10 mt-10">
        <div className="w-full max-w-3xl flex flex-col gap-12">
          {/* Edit Profile */}
          <form
            onSubmit={handleProfileUpdate}
            className="p-8 rounded-2xl border border-indigo-600/30 bg-gradient-to-br from-[#1a1a2e] via-[#151525] to-[#0f0f1a]"
          >
            <h3 className="text-3xl font-extrabold mb-6 text-white bg-clip-text text-transparent uppercase tracking-wide">
              Edit Profile
            </h3>
            <div className="flex flex-col gap-5">
              <input
                type="text"
                placeholder="First Name"
                value={user.firstname}
                onChange={(e) => setUser({ ...user, firstname: e.target.value })}
                className="bg-transparent border border-indigo-600/30 text-indigo-200 placeholder-indigo-400 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <input
                type="text"
                placeholder="Last Name"
                value={user.lastname}
                onChange={(e) => setUser({ ...user, lastname: e.target.value })}
                className="bg-transparent border border-indigo-600/30 text-indigo-200 placeholder-indigo-400 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              <button
                type="submit"
                className="mt-4 w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-md font-semibold transition-all duration-300 shadow-lg"
              >
                Save Profile
              </button>
            </div>
          </form>

          {/* Change Password */}
          <form
            onSubmit={handlePasswordChange}
            className="p-8 rounded-2xl border border-indigo-600/30 bg-gradient-to-br from-[#1a1a2e] via-[#151525] to-[#0f0f1a]"
          >
            <h3 className="text-3xl font-extrabold mb-6 text-white bg-clip-text text-transparent uppercase tracking-wide">
              Change Password
            </h3>
            <div className="flex flex-col gap-5">
              <input
                type="password"
                placeholder="Old Password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                className="bg-transparent border border-indigo-600/30 text-indigo-200 placeholder-indigo-400 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                required
              />
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="bg-transparent border border-indigo-600/30 text-indigo-200 placeholder-indigo-400 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                required
              />
              <input
                type="password"
                placeholder="Confirm New Password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                className="bg-transparent border border-indigo-600/30 text-indigo-200 placeholder-indigo-400 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                required
              />
              <button
                type="submit"
                className="mt-4 w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-md font-semibold transition-all duration-300 shadow-lg"
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Settings;